function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createBrowserHistory } from "history";
import { coreReducer } from "./core";
import { contextPanelIsInitiallyOpen } from "../nav-hooks";
import { createRouterReducer } from "@lagunovsky/redux-react-router";
import { hashStringReducer } from "./hash-string";
import { matchPath } from "react-router";
export var browserHistory = createBrowserHistory();
var routerReducer = createRouterReducer(browserHistory);

function menuReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    activePage: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "set-menu-page":
      return {
        activePage: action.page
      };

    default:
      return state;
  }
}

var defaultState = {
  core: coreReducer(undefined, {
    type: "init"
  }),
  router: routerReducer(undefined, {
    type: "init"
  }),
  menu: menuReducer(undefined, {
    type: "init"
  })
};

function mainReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  /** First, we operate over the entire state object.
   * Then, for actions that don't need to affect multiple sections of
   * state, we pass thm to individual reducers.
   */
  switch (action.type) {
    case "@@router/ON_LOCATION_CHANGED":
      {
        var pathname = action.payload.location.pathname;
        var isOpen = contextPanelIsInitiallyOpen(pathname);
        var s1 = setInfoMarkerPosition(state);
        return _objectSpread(_objectSpread({}, s1), {}, {
          core: _objectSpread(_objectSpread({}, s1.core), {}, {
            menuOpen: isOpen,
            contextPanelOpen: isOpen
          }),
          router: routerReducer(state.router, action)
        });
      }

    case "set-menu-page":
      return _objectSpread(_objectSpread({}, state), {}, {
        core: _objectSpread(_objectSpread({}, state.core), {}, {
          inputFocus: false
        }),
        menu: menuReducer(state.menu, action)
      });

    case "replace-state":
      return action.state;

    default:
      return {
        router: routerReducer(state.router, action),
        core: coreReducer(state.core, action),
        menu: menuReducer(state.menu, action)
      };
  }
}

var appReducer = function appReducer(state, action) {
  // This might not be the right way to do hash management, but it
  // centralizes the logic in one place.
  return hashStringReducer(mainReducer(state, action), action);
};

export function setInfoMarkerPosition(state) {
  // Check if we are viewing a specific location
  var loc = matchPath("/loc/:lng/:lat", state.router.location.pathname);

  if (loc != null) {
    var _loc$params = loc.params,
        lng = _loc$params.lng,
        lat = _loc$params.lat;
    return _objectSpread(_objectSpread({}, state), {}, {
      core: _objectSpread(_objectSpread({}, state.core), {}, {
        infoMarkerPosition: {
          lng: Number(lng),
          lat: Number(lat)
        },
        infoDrawerOpen: true
      })
    });
  }

  return state;
}
export default appReducer;
export * from "./core";
export * from "./map";
export * from "./types";